import { images } from './imageExporter';

export const navData = [
  {
    title: 'Daresay News',
    image: images.daresay_small,
    href: '/'
  },
  {
    title: 'Transactions',
    image: images.transactions,
    href: '/transactions'
  },
  {
    title: 'Connectivity',
    image: images.connectivity,
    href: '/connectivity'
  },
  {
    title: 'Public Sector',
    image: images.public_sector,
    href: '/publicsector'
  },
  {
    title: 'Health',
    image: images.health,
    href: '/health'
  }
];


// WEBPACK FOOTER //
// ./src/utils/navData.js